"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeSensorId = exports.SensorTabIndex = exports.SensorClassName = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */

var SizeSensorId = exports.SizeSensorId = 'size-sensor-id';
var SensorClassName = exports.SensorClassName = 'size-sensor-object';
var SensorTabIndex = exports.SensorTabIndex = '-1';